import type { ShopPosCartLine } from "@/modules/merchant/presentation/ui/ShopPosCheckoutModal";

export type ShopPosCartLineExt = ShopPosCartLine & {
  lotSummary?: string;
  /** ຍອດສູງສຸດຕາມ lot ຕອນເພີ່ມ (ບໍ່ລວມກັບ SKU ອື່ນ) */
  lotQtyCap?: number;
  serialLabel?: string;
};

export function posCartLineKey(
  l: Pick<ShopPosCartLineExt, "lineInstanceId">,
): string {
  return l.lineInstanceId;
}

export function lineGrossTotal(line: ShopPosCartLineExt): number {
  return line.row.price * line.qty;
}

export function lineDiscountCapped(line: ShopPosCartLineExt): number {
  const g = lineGrossTotal(line);
  if (line.lineDiscountUsePercent === true) {
    return Math.min((g * (line.lineDiscountPercent ?? 0)) / 100, g);
  }
  return Math.min(line.lineDiscountAmount ?? 0, g);
}
